var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCarouselIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "#2E3A59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.68599 14.6286H4.51456C4.51456 15.637 5.33468 16.4571 6.34314 16.4571H13.6574C14.6659 16.4571 15.486 15.637 15.486 14.6286H17.3146C18.323 14.6286 19.1431 13.8085 19.1431 12.8V3.65714C19.1431 2.64869 18.323 1.82857 17.3146 1.82857H15.486C15.486 0.820114 14.6659 0 13.6574 0H6.34314C5.33468 0 4.51456 0.820114 4.51456 1.82857H2.68599C1.67754 1.82857 0.857422 2.64869 0.857422 3.65714V12.8C0.857422 13.8085 1.67754 14.6286 2.68599 14.6286ZM17.3146 3.65714V12.8H15.486V3.65714H17.3146ZM6.34314 1.82857H13.6574L13.6583 14.6286H6.34314V1.82857ZM2.68599 3.65714H4.51456V12.8H2.68599V3.65714Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselIcon);
export default __webpack_public_path__ + "static/media/carousel-icon.be081224.svg";
export { ForwardRef as ReactComponent };